import React from "react";
import Header from "@/components/Header";
import ConversionStory from "@/components/ConversionStory";
import ProductsSectionLink from "@/components/ProductsSectionLink";
import TrustNumbers from "@/components/TrustNumbers";
import ErrorBoundary from "@/components/ErrorBoundary";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import SkipNavigation from "@/components/SkipNavigation";
import { useLanguage } from "@/contexts/LanguageContext";
import { OrganizationSchema, WebsiteSchema } from "@/components/StructuredData";
import Seo from "@/components/Seo";

const A11yTestHelper = React.lazy(() => import("@/components/A11yTestHelper"));

const Index = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title={t("home.seo.title")}
        description={t("home.seo.description")}
        canonical="https://quimical.com.br/"
      />
      <OrganizationSchema />
      <WebsiteSchema />
      <SkipNavigation />

      <ErrorBoundary componentName="Header">
        <Header />
      </ErrorBoundary>

      <main id="main-content" tabIndex={-1}>
        <ErrorBoundary componentName="ConversionStory">
          <ConversionStory />
        </ErrorBoundary>
        <ErrorBoundary componentName="ProductsSectionLink">
          <ProductsSectionLink />
        </ErrorBoundary>
        <ErrorBoundary componentName="TrustNumbers">
          <TrustNumbers />
        </ErrorBoundary>
      </main>

      <ErrorBoundary componentName="Footer">
        <Footer />
      </ErrorBoundary>
      <ErrorBoundary componentName="CookieConsent">
        <CookieConsent />
      </ErrorBoundary>
      <React.Suspense fallback={null}>
        <A11yTestHelper />
      </React.Suspense>
    </div>
  );
};

export default Index;

